<template>
  <v-container fluid>
    <transferItems
      :StoreInfo="UserInfo"
      BranchColor="warning"
      :headers="headers"
      :products="products"
    ></transferItems>
  </v-container>
</template>
<script>
import { tokenMixin } from "@/Mixins/tokenMixins.js";
import { mapGetters } from "vuex";
export default {
  components: {
    transferItems: () =>
      import("@/components/Branches/Transfer/transferProduct"),
  },

  mixins: [tokenMixin],
  data() {
    return {
      products: [],
      headers: [
        {
          text: "ORDER",
          align: "left",
          value: "code",
          groupable: true,
          class: "grey darken-3 white--text",
        },
        {
          text: "CATEG",
          align: "left",
          value: "AccountName",
          class: "grey darken-3 white--text",
        },
        {
          text: "ITEM",
          align: "left",
          value: "InvName",
          class: "grey darken-3 white--text",
        },
        {
          text: "QTY",
          value: "qty",
          class: "grey darken-3 white--text",
        },
        {
          text: "COST",
          value: "cost",
          class: "grey darken-3 white--text",
        },
        {
          text: "PRICE",
          value: "price",
          class: "grey darken-3 white--text",
        },
        {
          text: "CART",
          value: "cart",
          class: "grey darken-3 white--text",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getGroupedProducts"]),
    BranchColor() {
      return this.User.BranchType == "store"
        ? "primary darken-3"
        : "teal darken-3";
    },
    isStore() {
      return this.User.BranchType == "store";
    },
  },

  created() {
    if (!this.getGroupedProducts.length) this.$store.dispatch("LoadProdacts");
    // console.log(this.getGroupedProducts.length);
    // this.loadProducts();
  },
};
</script>
